import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = () => {
  return (
    <div className="loading-container">
      <div className="app-loading-spinner">
        <img
          src="/loading_animation.gif"
          alt="Loading..."
          className="loading-gif"
        />
      </div>
    </div>
  );
};

export default LoadingSpinner;
